import * as types from 'modules/questionModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {string | null} State */
const initialState = null;

const update = (_, { payload: selectedLocale }) => selectedLocale;

export default createReducer(initialState, {
  [types.SET_SELECTED_LOCALE]: update,
});
